<template>
  <div v-click-away="onClickAwayAway" class="gf_page-applied" :style="{ top: styleTopPageApplied + 'px' }">
    <div class="gf_page-applied__header">
      <div
        v-tooltip.top="{
          placement: 'top',
          content: 'Pages use ' + label,
          class: 'tooltip-page-applied',
        }"
        class="gf_page-applied__header-title">
        Pages use {{ label }}
      </div>
      <div class="gf_page-applied__header-action-close" @click="$emit('onHidePageApplied')">
        <i class="icon icon-close cursor-pointer" />
      </div>
    </div>
    <div class="gf_page-applied__body">
      <div class="gf_page-applied__body__list">
        <perfect-scrollbar class="scrollBody">
          <div
            v-for="(item, index) in listPagesApplied"
            :key="index"
            class="gf_page-applied__body__list__item"
            :class="{
              'mb-0': index == listPagesApplied.length - 1,
              'gf_page-applied__body__list__item--disable':
                permissionPlanForPageType(item.type) || isRunningCampaignId(item.runningCampaignId),
            }">
            <div class="gf_page-applied__body__list__item-icon">
              <i class="icon" :class="iconMapPageType(item.type)" />
            </div>
            <div class="gf_page-applied__body__list__item-label">
              <span
                v-tooltip.top="{
                  placement: 'top',
                  content: item.title,
                  class: 'tooltip-page-applied',
                }"
                class="gf_page-applied__body__list__item-label-span">
                {{ item.title }}
              </span>
              <span
                v-if="isRunningCampaignId(item.runningCampaignId)"
                class="gf_page-applied__body__list__item-label-ab-testing"
                >A/B Testing</span
              >
            </div>
            <div
              v-if="permissionPlanForPageType(item.type)"
              v-tooltip.top="{
                placement: 'top',
                content: txtTooltipForPageType(item.type),
                class: 'tooltip-page-applied tooltip-page-applied--max-width-184',
              }"
              class="gf_page-applied__body__list__item-lock"
              :class="{
                'gf_page-applied__body__list__item-lock--has-ab-testing': isRunningCampaignId(item.runningCampaignId),
              }">
              <i class="icon icon-lock" />
            </div>
            <template v-if="item.g_id != pageInfo.page.g_id">
              <template v-if="isRunningCampaignId(item.runningCampaignId) || permissionPlanForPageType(item.type)">
                <div class="gf_page-applied__body__list__item-button gf_page-applied__body__list__item-button--disable">
                  Edit
                </div>
              </template>
              <template v-else-if="item.editUrl">
                <div class="gf_page-applied__body__list__item-button" @click="onEditPage(item.editUrl)">Edit</div>
              </template>
            </template>
          </div>
        </perfect-scrollbar>
      </div>
    </div>
  </div>
</template>

<script>
import config from '@/app/editor/config';
import { cloneDeep } from '@/utils/common';
import { mapMutations } from 'vuex';
import { mutations } from '@modules/editor-sidebar';
import { dropPresetValueStyle } from '../../constants/styleConstant';
import { $gfLeftSideBar } from '@/app/index';
import { mapState } from 'vuex';

export default {
  name: 'ListPageApplied',
  props: {
    index: {
      type: Number,
      default: -1,
    },
    listPagesApplied: {
      type: Array,
      default: () => {
        return [];
      },
    },
    label: {
      type: String,
    },
    styleTopPageApplied: {
      type: Number,
      default: 0,
    },
  },
  data: () => ({}),
  computed: {
    ...mapState('app', {
      pageInfo: 'pageInfo',
      shopInfo: 'shopInfo',
    }),
  },
  methods: {
    onClickAwayAway() {
      this.$emit('onHidePageApplied');
    },
    onEditPage(editUrl) {
      const redirectUrl = config.domain() + editUrl;
      window.open(redirectUrl);
      return;
    },
    iconMapPageType(pageType) {
      switch (pageType) {
        case 'template-index':
          return 'icon-home-page';
        case 'template-page':
          return 'icon-landing-page';
        case 'template-article':
          return 'icon-article-page';
        case 'template-product':
          return 'icon-product-page';
        case 'template-collection':
          return 'icon-collection-page';
        default:
          return '';
      }
    },
    permissionPlanForPageType(pageType) {
      if (pageType == 'template-collection' || pageType == 'template-product' || pageType == 'template-article') {
        if (this.shopInfo.plan == 'trial' && this.shopInfo.remainingDays <= 0) {
          return true;
        }
        if (this.shopInfo.plan == 'starter') {
          return true;
        }
      }
      return false;
    },
    isRunningCampaignId(runningCampaignId) {
      return runningCampaignId && runningCampaignId > 0;
    },
    txtTooltipForPageType(pageType) {
      if (pageType == 'template-collection') {
        return 'Collection Page is available for Business Plan and higher';
      }
      if (pageType == 'template-product') {
        return 'Product Page is available for Business Plan and higher';
      }
      if (pageType == 'template-article') {
        return 'Article Page is available for Business Plan and higher';
      }
      return '';
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/app/editor/scss/variables';
@import '@/core/themes/vendor/color';
@import '@/core/themes/vendor/variables';
@import '@/core/themes/vendor/mixins';
.scrollBody {
  height: auto;
  max-height: 436px;
}
.gf_page-applied {
  background: map-get($hybrid-shade-dark, '400');
  width: 296px;
  height: auto;
  position: absolute;
  top: -150px;
  right: calc(-296px - 8px);
  border-radius: $radius;
  font-size: 12px;
  z-index: 10;
  @media screen and (max-height: 670px) {
    top: 160px;
  }
  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px;

    &-title {
      padding: 0 4px;
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      line-height: 16px;
      color: map-get($text-dark-mode, 'high-contrast');
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      flex-basis: 0;
      flex-grow: 1;
      max-width: 100%;
      line-height: 24px;
    }

    &-action-close {
      width: 24px;
      height: 24px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 3px;
      cursor: pointer;
      &:hover {
        background-color: map-get($hybrid-shade-dark, '300');
      }
      .cursor-pointer {
        cursor: pointer;
        font-size: 16px;
        color: map-get($text-dark-mode, 'high-contrast');
      }
    }
  }
  &__body {
    padding: 4px;
    padding-right: 0;
    padding-top: 0px;
    &__list {
      height: auto;
      max-height: 436px;
      &__item {
        padding: 8px;
        padding-right: 12px;
        background: map-get($hybrid-shade-dark, '400');
        border-radius: 3px;
        display: flex;
        align-items: center;
        margin-bottom: 4px;
        color: white;
        position: relative;
        width: calc(100% - 4px);
        &:last-child {
          margin-bottom: 0px;
        }
        &:hover {
          background: map-get($hybrid-shade-dark, '300');
          .gf_page-applied__body__list__item-button {
            display: flex;
          }
        }

        &-icon {
          margin-right: 8px;
          width: 16px;
          display: flex;
          align-items: center;
          justify-content: center;
          .icon {
            font-size: 16px;
          }
        }

        &-label {
          flex: auto;
          font-style: normal;
          font-weight: 500;
          font-size: 12px;
          height: 24px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          color: map-get($text-dark-mode, 'high-contrast');
          margin-right: 4px;
          display: flex;
          align-items: center;
          &-span {
            width: fit-content;
            line-height: 16px;
            max-width: 100%;
            display: block;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          &-ab-testing {
            font-style: normal;
            font-weight: 500;
            font-size: 12px;
            line-height: 16px;
            color: map-get($accent-color-amber, '500');
            background-color: map-get($accent-color-amber, '100');
            margin-left: 8px;
            padding: 0 4px;
            width: 75px;
            height: 16px;
            display: flex;
            align-items: center;
            border-radius: 3px;
            cursor: context-menu;
          }
        }
        &-lock {
          display: flex;
          margin-right: 4px;
          .icon-lock {
            font-size: 16px;
            color: map-get($text-dark-mode, 'disabled');
          }
          &--has-ab-testing {
            margin-left: 8px;
          }
        }
        &-button {
          display: none;
          font-style: normal;
          font-weight: 500;
          font-size: 12px;
          line-height: 14px;
          color: map-get($hybrid-shade-light, '100');
          padding: 5px 0;
          width: 39px;
          min-width: 39px;
          height: 24px;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          margin-right: -4px;
          &:hover {
            background: map-get($hybrid-shade-dark, '200');
            border-radius: 3px;
          }
          &--disable {
            cursor: context-menu;
            color: map-get($text-dark-mode, 'disabled');
            background: map-get($hybrid-shade-dark, '300');
            &:hover {
              background: map-get($hybrid-shade-dark, '300');
            }
          }
        }
        &--disable > div {
          color: map-get($text-dark-mode, 'disabled');
        }
      }
    }
  }
}
</style>
